import { RevisionAnnotation } from "~/types/RevisionAnnotation";

export const useAnnotationTokenHighlight = defineStore(
  "annotation-token-highlight",
  () => {
    const activeAnnotation = ref<RevisionAnnotation | undefined>(undefined);
    const tokenGlobalPositions = ref<number[]>([]);

    const setHoverAnnotation = (newAnnotation?: RevisionAnnotation) => {
      activeAnnotation.value = newAnnotation;
      tokenGlobalPositions.value = newAnnotation?.tokenGlobalPositions ?? [];
    };

    return { setHoverAnnotation, tokenGlobalPositions, activeAnnotation };
  }
);
